import { createAPI } from '@/utils/request'
import { serviceGetWay } from '@/getWay/index'

export  const login = data => createAPI(`/user/authentication/form?username=${data.username}&password=${data.password}`,'post',null)
export  const register = data => createAPI(`/user/register`,'post',data)
export  const isLogin = data => createAPI(`${serviceGetWay.qms}/user/login_info`,'get',data)
export  const page = data => createAPI(`${serviceGetWay.qms}/user/page`,'get',data)
export  const exist = data => createAPI(`/user/exist`,'get',data)
export  const resetPwd = data => createAPI(`/user/reset_pwd`,'post',data)
export  const loginOut = data => createAPI(`/user/login_out`,'get',null)



// WEBPACK FOOTER //
// ./src/api/userApi.js